import React, { useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import usePlans from "../../services/LandingPage/usePlans";
import Campaign from "../../images/campaign_analytics_1x.webp";
import Order from "../../images/order_management_1x.webp";
import Team from "../../images/inbox_team_1x.webp";
import BroadCast from "../../images/broadcast_1x.webp";
import "./LandingPage.css";

const BusinessImpact = () => {
  const { baseUrl } = useContext(GlobalContext);
  const { refetch: fetchSubscriptionPlans } = usePlans("IN");

  const featuresRef = useRef(null);
  const [activeFeature, setActiveFeature] = useState(
    "Smart Campaign Management",
  );
  const [isChanging, setIsChanging] = useState(false);

  const features = [
    "Smart Campaign Management",
    "Marketing Performance Analysis",
    "Unified Team Inbox for Efficient Support",
    "Sales & Inventory Management",
  ];

  const handleButtonClick = (feature) => {
    setIsChanging(true);
    setTimeout(() => {
      setActiveFeature(feature);
      setIsChanging(false);
    }, 300);
  };

  const featureContent = {
    "Smart Campaign Management": {
      title: "Smart Campaign Management",
      description: `Easily create and manage one-time or recurring campaigns with our platform. Customize alerts and updates to match your customers’ preferences, ensuring every message is relevant and engaging. Boost interaction and drive more conversions with timely notifications.`,
      subtitle:
        "Track your campaign results effortlessly with our intuitive tools. Gain real-time insights, refine strategies on the go, and maintain seamless communication. Our system is designed to optimize campaign performance and maximize your reach.",
      image: BroadCast,
    },
    "Marketing Performance Analysis": {
      title: "Marketing Performance Analysis",
      description: `Monitor and evaluate your campaigns effortlessly with Anlook. Gain clear insights into what works best, allowing you to fine-tune strategies that boost engagement, conversions and overall business growth. `,
      subtitle:
        "Track ROI, segment audiences, and optimize content with ease. Anlook provides actionable data and tools to transform your marketing efforts into measurable success. Stay ahead in the competitive landscape and make every campaign count.",
      image: Campaign,
    },
    "Unified Team Inbox for Efficient Support": {
      title: "Unified Team Inbox for Efficient Support",
      description: `Handle customer queries instantly with a centralized platform. Our solution automatically routes each message to the right team member, enabling smooth collaboration and faster issue resolution.`,
      subtitle:
        "Track team performance effortlessly using detailed analytics, optimize workflows, and improve conversion rates. This all-inclusive platform helps your business deliver superior service while maintaining operational efficiency.",
      image: Team,
    },
    "Sales & Inventory Management": {
      title: "Sales & Inventory Management",
      description:
        "Transform the way you handle your business sales with a smart WhatsApp storefront. Customers can explore products, place orders, and pay seamlessly, boosting engagement and loyalty. Our complete solution equips you with powerful tools to manage inventory, orders, and customer interactions efficiently.",
      subtitle:
        "Empower your business with a modern approach to customer engagement. Streamline processes, personalize interactions, and drive growth with WhatsApp storefronts your gateway to selling, connecting, and thriving in a competitive market.",
      image: Order,
    },
  };

  useEffect(() => {
    if (baseUrl) {
      fetchSubscriptionPlans();
    }
  }, [fetchSubscriptionPlans]);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentIndex = features.indexOf(activeFeature);
      const nextIndex = (currentIndex + 1) % features.length;

      setIsChanging(true);

      setTimeout(() => {
        setActiveFeature(features[nextIndex]);
        setIsChanging(false);
      }, 300);
    }, 5000);

    return () => clearInterval(interval);
  }, [activeFeature]);

  return (
    <div
      className="My-Landing-features bg-white py-20"
      id="features"
      ref={featuresRef}
    >
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="My-Landing-features-title text-2xl md:text-3xl font-bold text-center text-gray-800 mb-12">
          Unlock Anlook’s Advanced Tools for Maximum Business Impact
        </h1>

        <div className="main-responsive-flex flex flex-col md:flex-row gap-4 mb-10">
          {features.map((feature) => (
            <button
              key={feature}
              className={`My-Landing-feature-button ${
                activeFeature === feature ? "active" : ""
              }`}
              onClick={() => handleButtonClick(feature)}
            >
              {feature}
            </button>
          ))}
        </div>

        <div className="My-Landing-feature-content flex flex-col lg:flex-row items-center gap-10">
          <img
            src={featureContent[activeFeature].image}
            className={`My-Landing-feature-image-placeholder w-full max-w-[300px] sm:max-w-md object-contain transition-all duration-300 ${
              isChanging ? "opacity-0 scale-95" : "opacity-100 scale-100"
            }`}
            alt="feature"
          />

          <div
            className={`My-Landing-feature-text transition-all duration-300 ${
              isChanging
                ? "opacity-0 translate-y-2"
                : "opacity-100 translate-y-0"
            }`}
          >
            <h2 className="montserrat-font-1 text-2xl md:text-3xl font-semibold text-gray-800 mb-4">
              {featureContent[activeFeature].title}
            </h2>
            <p className="montserrat-font-2 text-gray-600 mb-4 leading-relaxed">
              {featureContent[activeFeature].description}
            </p>
            <p className="montserrat-font-2 text-gray-600 leading-relaxed">
              {featureContent[activeFeature].subtitle}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessImpact;
